import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Utils from '../../utils';
import { counterTypes } from '../../utils/TimestampManager';
import { getText, TEXT_KEY } from '../../utils/localization';
import { fetchGameRooms } from '../../state/query/games/utils';
import { MISSIONS_TYPES } from '../../screens/Missions/constants';
import { TYPEOF } from '../../constants';
var TimeRemainingText = /*#__PURE__*/function (_Component) {
  function TimeRemainingText() {
    var _this;
    _classCallCheck(this, TimeRemainingText);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TimeRemainingText, [].concat(args));
    _this.state = {
      now: new Date()
    };
    _this.timer = null;
    _this.checkToKeepEvent = function (eventType) {
      if (eventType === counterTypes.SNEAK_PEEK) fetchGameRooms(true);
    };
    return _this;
  }
  _inherits(TimeRemainingText, _Component);
  return _createClass(TimeRemainingText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.timer = setInterval(function () {
        return _this2.setState({
          now: new Date()
        });
      }, this.props.interval || 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var string = '';
      var now = this.state.now;
      var _this$props = this.props,
        activeTutorial = _this$props.activeTutorial,
        until = _this$props.until,
        _this$props$prefix = _this$props.prefix,
        prefix = _this$props$prefix === void 0 ? '' : _this$props$prefix,
        _this$props$postfix = _this$props.postfix,
        postfix = _this$props$postfix === void 0 ? '' : _this$props$postfix,
        _this$props$hideOnFin = _this$props.hideOnFinish,
        hideOnFinish = _this$props$hideOnFin === void 0 ? false : _this$props$hideOnFin,
        hideTimer = _this$props.hideTimer,
        hideTimerOnFinish = _this$props.hideTimerOnFinish,
        counterType = _this$props.counterType,
        endTimerCallback = _this$props.endTimerCallback,
        shouldShowTooltip = _this$props.shouldShowTooltip,
        tooltipDetails = _this$props.tooltipDetails,
        modal = _this$props.modal,
        inNavBar = _this$props.inNavBar,
        showMissionsProgressBar = _this$props.showMissionsProgressBar,
        setShowMissionsProgressBar = _this$props.setShowMissionsProgressBar,
        currentMission = _this$props.currentMission;
      var secureUntil = until || new Date();
      var _Utils$buildTimeRemai = Utils.buildTimeRemaining(now, secureUntil, counterType, getText),
        timeString = _Utils$buildTimeRemai.timeString,
        isTimeInDanger = _Utils$buildTimeRemai.isTimeInDanger;
      if (timeString && timeString !== '00:00:00') {
        string = "".concat(prefix).concat(timeString).concat(postfix);
      } else {
        if (typeof endTimerCallback === TYPEOF.FUNCTION) endTimerCallback();
        this.checkToKeepEvent(counterType);
        if (hideOnFinish) return null;
        if (!hideTimer) hideTimerOnFinish(true);
        switch (counterType) {
          case counterTypes.MISSION_CARD:
            string = "".concat(prefix, "00").concat(getText(TEXT_KEY.TIMER_LEFT_HOUR), " 00").concat(getText(TEXT_KEY.TIMER_LEFT_MINUTE));
            isTimeInDanger = true;
            break;
          case counterTypes.MISSION_GRAND_CARD:
            string = "".concat(prefix, "00").concat(getText(TEXT_KEY.TIMER_LEFT_DAY), " 00").concat(getText(TEXT_KEY.TIMER_LEFT_HOUR));
            isTimeInDanger = true;
            break;
          case counterTypes.EVENTS:
            string = "".concat(prefix, "00").concat(getText(TEXT_KEY.TIMER_LEFT_HOUR), " 00").concat(getText(TEXT_KEY.TIMER_LEFT_MINUTE));
            break;
          case counterTypes.MISSION_PROGRERSS_BAR:
            string = '00:00:00';
            break;
          default:
            string = '...';
            break;
        }
      }
      if (counterType === counterTypes.MISSION_PROGRERSS_BAR && (currentMission === null || currentMission === void 0 ? void 0 : currentMission.missionType) === MISSIONS_TYPES.EXPLORER && inNavBar && showMissionsProgressBar && secureUntil - now <= 0) setShowMissionsProgressBar(false);
      return this.props.render({
        string: string,
        isTimeInDanger: isTimeInDanger,
        shouldShowTooltip: shouldShowTooltip,
        tooltipDetails: tooltipDetails,
        modal: modal,
        showMissionsProgressBar: showMissionsProgressBar,
        activeTutorial: activeTutorial
      });
    }
  }]);
}(Component);
export { TimeRemainingText as default };